import { render, staticRenderFns } from "./SectionFaq.vue?vue&type=template&id=72604d69&scoped=true&"
import script from "./SectionFaq.vue?vue&type=script&lang=js&"
export * from "./SectionFaq.vue?vue&type=script&lang=js&"
import style0 from "./SectionFaq.vue?vue&type=style&index=0&id=72604d69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72604d69",
  null
  
)

export default component.exports